(function ($) {
	$('.menu-item.menu-item-has-children').addClass('open');
	$('.menu-item.menu-item-has-children').click(function() {
		$(this).toggleClass('open');
	});

	$('.header_btn-burger').click(function() {
		$(this).toggleClass('active');
		$('.header_burger-menu').toggleClass('open');
		$('body').toggleClass('not-scroll');
	});

	$('.footer_menu .title').addClass('open');
	$('.footer_menu .title').click(function() {
		$(this).toggleClass('open');
	});

	$('.header_options__btn').click(function() {
		$('.search').toggleClass('open');
	});
	$('.search_close').click(function() {
		$('.search').removeClass('open');
	});
	$(document).mouseup( function(e){ 
		var search = $( ".header .search" );
		if ( !search.is(e.target) && search.has(e.target).length === 0 ) { 
			search.removeClass('open');
		}
	});
	$('.search_wrap input').keyup(function() {
		if ($(this).val().length >= 1) {
			$('.search_clear').addClass('visible');
		}else {
			$('.search_clear').removeClass('visible');
		}
	});
	$('.search_clear').click(function() {
		$('.search_wrap input').val('');
		$('.search_clear').removeClass('visible');
	});

	$('.faq-content').hide();
	$('.faq-title').click(function() {
		$(this).toggleClass('active');
		$(this).next('.faq-content').slideToggle(300);
	});

	function modal() {
		$('.btn--modal').on('click', function (e) {
			e.preventDefault();
     	let target = "#" + $(this).data("target");
			$("body").addClass("no-scroll");
			$('.modal').removeClass("open");
			$(target).addClass('open');
		});
		$('.modal_close').click(function() {
	  	$('.modal').removeClass('open');
	  	$('body').removeClass('no-scroll');
	  });
	  $('.modal_notification .close').click(function() {
	  	$('.modal_notification').removeClass('visible');
	  });
	}
	modal();

	$('.icon-pass').click(function() {
    const input = $(this).siblings('input');
    const type = input.attr('type') === 'password' ? 'text' : 'password';
    input.attr('type', type);
    $(this).toggleClass('active');
	});

})(jQuery);